import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../components/Sidebar";
import { ReactComponent as BackArrow } from "../assets/leftArrow.svg";
import { useHistory } from "react-router";
import Mode from "./Mode";

function CalculatorSummarySheet() {
  const history = useHistory();
  const [sidebar, setSidebar] = useState(false);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#48B7A7",
      },
      background: {
        paper: "#E8F9FD",
      },
    },
  });

  return (
    <>
    <ThemeProvider theme={theme}>
      <Container fluid className="pl-0">
        <Row>
          <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
        </Row>
        <div className="summary-sheet-section">
          <h3 className="mb-4 d-flex align-items-center">
            <div className="summary-sheet-back-icon mr-2">
              <BackArrow className="ml-1 mb-2" onClick={() => history.goBack()} />
            </div>
            <h3>Calculator Summary Sheet</h3>
          </h3>
          <div>
            <div className="mt-4">
              <h4>
                <span className="summary-sheet-title">Profit per product</span>{" "}
                tells you what amount of a sale you keep after paying of the
                cost of materials, services provider fees and shipping.
              </h4>
              <p className="mt-5 ml-4 d-flex">
                <span className="font-weight-bold summary-space">Example:&nbsp;&nbsp;&nbsp;</span>
                <p>
                  <p>
                    You sell a bath bomb for $8 but spend $2 on materials, $0.75
                    on services provider fees and $0.50 on shipping.
                  </p>
                  <p>
                  The cost of the sale or revenue is $8, but your profit or the amount you keep is <span className="font-weight-bold">$4.75.</span>
                  </p>
                </p>
              </p>
            </div>
            <div className="mt-4">
              <h4>
                <span className="summary-sheet-title">Break even point</span>{" "}
                indicates how many units you have to sell to pay off your fixed costs.
              </h4>
              <p className="mt-5 ml-4 d-flex">
                <span className="font-weight-bold summary-space">Example:&nbsp;&nbsp;&nbsp;</span>
                <p>
                  <p>
                    You spend $100 on a machine to print stickers and $75 on sticker paper and ink. You sell each sticker for <span className="font-weight-bold">$1.50.</span>
                  </p>
                  <p>
                    Your break even point would be 117 stickers; once you sell 117 stickers, you will have paid off the cost of equipment and materials required to print the stickers.
                  </p>
                </p>
              </p>
            </div>
            <div className="mt-4">
              <h4>
                <span className="summary-sheet-title">Profit margin</span>{" "}
                helps you understand what percent of your revenue or sales you keep.
              </h4>
              <p className="mt-5 ml-4 d-flex">
                <p className="font-weight-bolder summary-space">
                  A suggestion standard for how to evaluate your profit margin:
                  <p className="mt-2"><span className="font-weight-bold text-success">Good:</span> &gt; 20%</p>
                  <p><span className="font-weight-bold text-warning">Average:</span> &#x7e; 10%</p>
                  <p><span className="font-weight-bold text-danger">Low:</span> &lt; 5%</p>
                </p>
              </p>
            </div>
            <div className="mt-4">
              <h4>
                <span className="summary-sheet-title">Conversion&nbsp;</span>{" "}
                helps determine what the equivalent profit would be in a different currency.
              </h4>
            </div>
          </div>
        </div>
      </Container>
    </ThemeProvider>
    <Mode/>
    </>
  );
}

export default CalculatorSummarySheet;
